import get from 'lodash/get';
import { createSelector } from 'reselect';

export const getPagination = (state) => get(state, 'catalogs.list.pagination', {});
export const getFilters = (state) => get(state, 'catalogs.list.filters', {});

export const getCatalogsIds = (state) => get(state, 'catalogs.list.result.catalogs', []);
export const getCatalogs = (state) => get(state, 'catalogs.list.entities.catalogs', {});

export const getIsLoading = (state) => get(state, 'catalogs.list.isLoading', false);
export const getNeedFetch = (state) => get(state, 'catalogs.list.needFetch', false);

export const getIsFetching = (state) => get(state, 'catalogs.form.isFetching', false);
export const getIsFetchingConfig = (state) => get(state, 'catalogs.form.isFetchingConfig', false);
export const getIsSaving = (state) => get(state, 'catalogs.form.isSaving', false);
export const getEditing = (state) => get(state, 'catalogs.form.editing', false);

export const getVisibleCatalogs = createSelector([getCatalogsIds, getCatalogs], (ids, catalogs) =>
  ids.map((id) => catalogs[id]).filter((catalog) => !catalog.deleted)
);



// WEBPACK FOOTER //
// src/modules/secured/modules/catalogs/selectors/catalogs_selectors.js